import React, { useState } from 'react';
import { ArrowRightIcon, CheckIcon, CircleAlertIcon, SparklesIcon } from 'lucide-react';
import { readiness } from '../../data/loisirs';
export function ReadinessCard() {
  const [fixed, setFixed] = useState(false);
  return <section aria-labelledby="pret-titre" className="rounded-3xl border border-slate-200 bg-white p-6 sm:p-7" data-id="element-1658" data-mp="14quiixy7pzsu">
      <div className="flex items-start gap-3" data-id="element-1659" data-mp="1enqtrbfhx013">
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-ville-indigo-soft text-ville-indigo" aria-hidden="true" data-id="element-1660" data-mp="1emp86d0usv54">
          <SparklesIcon className="h-5 w-5" data-id="element-1661" data-mp="19mtd53a4we1p" />
        </span>
        <div className="min-w-0" data-id="element-1662" data-mp="1ner3jww2fl8j">
          <h2 id="pret-titre" className="text-lg font-extrabold tracking-tight text-ville-navy" data-id="element-1663" data-mp="1ni53yzl65kdc">
            Prêt pour votre inscription
          </h2>
          <p className="mt-1 text-sm text-slate-600" data-id="element-1664" data-mp="1xf9vlexsa81j">
            {readiness.activity} · ouverture {readiness.opensOn}
          </p>
        </div>
      </div>

      {fixed ? <p className="mt-5 flex items-center gap-2 rounded-2xl bg-ville-indigo-soft px-4 py-3 text-sm font-semibold text-ville-indigo" data-id="element-1665" data-mp="1wmit0j0qw7c1">
          <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-1666" data-mp="21m53wlt3pbho" />
          Tout est prêt pour l’inscription de {readiness.opensOn}.
        </p> : <div className="mt-5 rounded-2xl border border-slate-200 bg-slate-50 p-5" data-id="element-1667" data-mp="2am1u4rv52ieu">
          <p className="flex items-start gap-2 text-[15px] font-bold text-ville-navy" data-id="element-1668" data-mp="2ajp7i1efrjvg">
            <CircleAlertIcon className="mt-0.5 h-5 w-5 shrink-0 text-ville-indigo" aria-hidden="true" data-id="element-1669" data-mp="2fj0rdja3n5h9" />
            {readiness.blocking.label}
          </p>
          <p className="mt-1.5 pl-7 text-sm text-slate-600" data-id="element-1670" data-mp="2pbzesxtv0pza">{readiness.blocking.detail}</p>
          <button type="button" onClick={() => setFixed(true)} className="ml-7 mt-4 inline-flex items-center gap-2 rounded-full bg-ville-navy px-5 py-2.5 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-1671" data-mp="2uaanv6cbywgg">
            Corriger maintenant
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1672" data-mp="z8fon8idshz8" />
          </button>
        </div>}

      <ul className="mt-5 flex flex-wrap gap-x-5 gap-y-2" data-id="element-1673" data-mp="1czkhnrr8uc0l">
        {readiness.checks.map(check => {
        const ok = fixed || check.ok;
        return <li key={check.id} className="flex items-center gap-2 text-sm" data-id="element-1674" data-mp="1mve0ttzgx3rc">
              <span className={`grid h-5 w-5 place-items-center rounded-full ${ok ? 'bg-ville-indigo-soft text-ville-indigo' : 'bg-slate-200 text-slate-500'}`} aria-hidden="true" data-id="element-1675" data-mp="1hxm6yuf9j7ki">
                {ok ? <CheckIcon className="h-3 w-3" data-id="element-1676" data-mp="1qw7p4ogtokkr" /> : <CircleAlertIcon className="h-3 w-3" data-id="element-1677" data-mp="1ikpqx8t5z73" />}
              </span>
              <span className={ok ? 'text-slate-600' : 'font-semibold text-ville-navy'} data-id="element-1678" data-mp="3spf3nvom2y5l">{check.label}</span>
            </li>;
      })}
      </ul>
    </section>;
}